import type { PdfValueSource } from '../types';

export interface PdfEngineIssue { code: string; message: string; documentId?: string; pageIndex?: number; placementId?: string; questionId?: string; source?: PdfValueSource }
/** Messages contain configuration locations, never participant values or template bytes. */
export class PdfEngineError extends Error {
  constructor(public readonly issues: PdfEngineIssue[]) {
    super(issues.map(issue => issue.message).join(' '));
    this.name = 'PdfEngineError';
  }
}
